module.exports = __webpack_public_path__ + "static/media/Landing-Page-Small-Rug-2.cd386f94.jpg";